"use client"
import { graphql, useMutation, type VariablesOf } from "@opensea/graphql"
import { useState } from "react"
import { uploadFile } from "@/lib/upload"

export const UPDATE_COLLECTION_MUTATION = graphql(`
  mutation StudioEditCollectionDetailsImagesMutation(
    $slug: String!
    $input: ModifyCollectionInput!
  ) {
    modifyCollection(slug: $slug, input: $input) {
      success
      error {
        ... on UnknownModifyCollectionError {
          message
        }
      }
    }
  }
`)

const MUTATION = graphql(`
  mutation UseCollectionImageUpload(
    $collectionSlug: String!
    $imageType: ImageType!
  ) {
    uploadCollectionImage(
      collectionSlug: $collectionSlug
      imageType: $imageType
    ) {
      url
      method
      fields
      token
    }
  }
`)

type CollectionImageType = VariablesOf<typeof MUTATION>["imageType"]

export function useCollectionImageUpload(
  collectionSlug: string,
  imageType: CollectionImageType,
) {
  const [_, execute] = useMutation(MUTATION)
  const [isUploading, setIsUploading] = useState(false)

  async function upload(file: File) {
    setIsUploading(true)
    try {
      const { data, error } = await execute({ collectionSlug, imageType })
      if (error) {
        throw error
      }
      if (data?.uploadCollectionImage) {
        return await uploadFile(data.uploadCollectionImage, file)
      }
      throw new Error("Failed to upload file")
    } finally {
      setIsUploading(false)
    }
  }

  return { upload, isUploading }
}
